import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import SVG from 'react-inlinesvg'
import Button from '../../components/Button'

import chevron from '../../assets/svg/chevron.svg'

import { bistrochatLinks } from '../../constants/bistrochat'

const Wrapper = styled.form`
  position: relative;
  width: 100%;
  padding: 40px 30px 120px 30px;
  border-radius: 8px;
  background: rgba(37, 37, 37, 0.88);

  ${({ theme }) => theme.media.l} {
    display: flex;
    padding: 20px 240px 20px 0;
  }

  ${({ theme }) => theme.media.xl} {
    padding: 30px 240px 30px 40px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding: 40px 240px 40px 40px;
  }
`

const InputWrapper = styled.div`
  position: relative;
  z-index: 500;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 20px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  > input {
    width: 100%;
    padding: 5px 40px 5px 0;
    caret-color: transparent;
    text-overflow: ellipsis;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.3s ease;

    &:focus {
      opacity: 1;
    }

    ::placeholder {
      color: white;
    }
  }

  > svg {
    position: absolute;
    top: 10px;
    right: 0;
    display: block;
    width: 15px;
    height: 15px;
    pointer-events: none;
    transform: rotate(180deg);
  }

  ${({ theme }) => theme.media.l} {
    margin: 0;
    padding: 5px 10px 5px 20px;
    border-bottom: 0;

    > svg {
      position: absolute;
      top: 10px;
      right: 25px;
    }
  }
`

const RestaurantSelect = styled.ul`
  z-index: 700;
  list-style: none;
  overflow-y: scroll;
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  width: 100%;
  height: 300px;
  background: rgba(22, 22, 22, 0.88);
  padding: 30px 30px 0 0;

  ${({ visible }) =>
    visible
      ? css`
          opacity: 1;
          pointer-events: auto;
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `}

  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;
  }

  ::-webkit-scrollbar {
    width: 12px;
    background-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.primary};
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0);
  }

  > li {
    position: relative;
    padding: 15px 20px;
    font-weight: ${({ theme }) => theme.font.light};
    color: #747474;
    letter-spacing: 0.03em;
    cursor: pointer;

    :before {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 20px;
      height: 1px;
      background: white;
      opacity: 0.1;
    }

    span {
      font-weight: ${({ theme }) => theme.font.bold};
    }

    :hover {
      background: ${({ theme }) => theme.colors.primary};
      color: #1f2123;
    }
  }

  ${({ theme }) => theme.media.l} {
    right: 250px;
    top: 60px;
    height: 250px;
  }

  ${({ theme }) => theme.media.xl} {
    top: 68px;
  }

  ${({ theme }) => theme.media.xxl} {
    top: 80px;
  }
`

const SVGchevron = styled(SVG)`
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`

const SubmitButton = styled.a`
  z-index: 3;
  position: absolute;
  bottom: 0;
  left: 0;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 35px 0;
  border-radius: 0 0 8px 8px;
  background: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.font.bold};
  text-transform: uppercase;

  ${({ theme }) => theme.media.l} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: auto;
    width: 250px;
    border-radius: 0 8px 8px 0;
    padding: 25px 0;
  }
` 

const FormBook = ({ data }) => {
  
  const [currentId, setCurrentId] = useState(61)
  const [currentItem, setCurrentItem] = useState('')
  const [currentSlug, setCurrentSlug] = useState('')
  const [focused, setFocused] = useState(false)

  const handleClick = (name, id, item) => {
    setCurrentId(id)
    setCurrentItem(item)
    setCurrentSlug(name)
  }

  const bistrochat = bistrochatLinks

  return (
    <div>
      <Wrapper>
        <InputWrapper>
          <input
            placeholder="Choose a restaurant..."
            type=""
            name=""
            value={
              currentItem &&
              `${currentItem.Name} / Cuisine : ${currentItem.cuisine['Name']} / Adress : ${currentItem.Address}`
            }
            onFocus={() => setFocused(true)}
            onBlur={() => setTimeout(() => setFocused(false), 100)}
          />
          <RestaurantSelect visible={focused}>
            {data.map(
              (item, index) =>
                item.node.bookingsId && (
                  <li
                    key={item.node.bookingsId}
                    onClick={() =>
                      handleClick(item.node.slug, item.node.bookingsId, item.node)
                    }
                  >
                    <span>{item.node.Name}</span> / Address : {item.node.Address}
                  </li>
                )
            )}
          </RestaurantSelect>
          <SVGchevron src={chevron} onClick={() => setFocused(true)} />
        </InputWrapper>
        <SubmitButton
          href={bistrochat[currentSlug]}
          target="blank"
        >
          Book a table
        </SubmitButton>
      </Wrapper>
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h3>or enjoy your meal at home</h3>
        <h3>Hong Kong Island & Kowloon Wide Delivery</h3>
        <a
          href="https://sandshospitality.oddle.me"
          target="blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block', marginBottom: '45px', marginLeft: '15px' }}
        >
          <Button>ORDER NOW</Button>
        </a>
      </div>
    </div>
  )
}

export default FormBook
